export default "__VITE_PUBLIC_ASSET__21e0e9de__"